import React from "react";
import { WordGuess } from "./WordGuess";
import { registerGame } from "../common/registry";
import { Game } from "../common/types";

// WordGuess için icon
const WordGuessIcon: React.ReactNode = (
  <div className="w-full h-full flex items-center justify-center">
    <div className="grid grid-cols-5 gap-1 w-full h-full p-2">
      {["", "", "", "", ""].map((_, index) => (
        <span
          key={`word-box-${index}`}
          className={`h-4 w-4 rounded-sm border border-border-secondary dark:border-gray-600 ${
            index === 1 || index === 3
              ? "bg-bg-tertiary dark:bg-gray-700"
              : "bg-bg-primary dark:bg-gray-800"
          }`}
        />
      ))}
    </div>
  </div>
);

// Kelime Tahmin oyununu kaydet
const wordGuessGame: Game = {
  id: "word-guess",
  name: "games.list.wordGuess.title",
  description: "games.list.wordGuess.description",
  component: WordGuess,
  icon: WordGuessIcon,
  category: "word",
};

// Oyunu otomatik kaydet
registerGame(wordGuessGame);

export { WordGuess };
export default wordGuessGame;
